import { render } from "./FilterCurrents.vue?vue&type=template&id=7e9e89ca&ts=true"
import script from "./FilterCurrents.vue?vue&type=script&lang=ts"
export * from "./FilterCurrents.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__